import _classCallCheck from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "D:\\repos\\finam.portal.onboarding\\NewbiePortal\\newbie_app\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import { UAParser } from 'ua-parser-js';
import { v1 as uuid } from 'uuid';
import { Device, DeviceInfoKey } from './proto';
var PLATFORM = 'html5';
/* eslint-disable class-methods-use-this */

var DeviceBuilder = /*#__PURE__*/function () {
  function DeviceBuilder(appName, appVersion, widgetVersion, getLocalId, setLocalId) {
    _classCallCheck(this, DeviceBuilder);

    this.appName = appName;
    this.appVersion = appVersion;
    this.widgetVersion = widgetVersion;
    this.uaParser = new UAParser();
    this.getLocalId = getLocalId;
    this.setLocalId = setLocalId;
  }

  _createClass(DeviceBuilder, [{
    key: "build",
    value: function build() {
      var device = Device.create();
      var cachedLocalId = this.getLocalId(this.appName);

      if (cachedLocalId) {
        device.localId = cachedLocalId;
      } else {
        var localId = uuid();
        this.setLocalId(this.appName, localId);
        device.localId = localId;
      }

      var deviceInfo = this.getDeviceInfo();
      device.name = deviceInfo.name;
      var infoMap = device.info;
      infoMap[DeviceInfoKey.PLATFORM] = deviceInfo.platform;
      infoMap[DeviceInfoKey.OS_VERSION] = deviceInfo.osVersion;
      infoMap[DeviceInfoKey.VENDOR] = deviceInfo.vendor;
      infoMap[DeviceInfoKey.MODEL] = deviceInfo.model;
      infoMap[DeviceInfoKey.SCREEN_RESOLUTION] = deviceInfo.screenResolution;
      infoMap[DeviceInfoKey.CPU_ARCH] = deviceInfo.cpuArch;
      infoMap[DeviceInfoKey.CPU_COUNT] = deviceInfo.cpuCount;
      infoMap[DeviceInfoKey.GPU_VENDOR] = deviceInfo.gpuVendor;
      infoMap[DeviceInfoKey.GPU_RENDERER] = deviceInfo.gpuRenderer;
      infoMap[DeviceInfoKey.LANG] = deviceInfo.lang;
      infoMap[DeviceInfoKey.TIMEZONE] = deviceInfo.timezone;
      infoMap[DeviceInfoKey.APP_NAME] = this.appName;
      infoMap[DeviceInfoKey.APP_VERSION] = this.appVersion;

      if (this.widgetVersion) {
        infoMap[DeviceInfoKey.TXAUTH_WIDGET_VERSION] = this.widgetVersion;
      }

      return device;
    }
  }, {
    key: "getDeviceInfo",
    value: function getDeviceInfo() {
      if (DeviceBuilder.deviceInfo) {
        return DeviceBuilder.deviceInfo;
      }

      var gpu = this.getGpuInfo();
      DeviceBuilder.deviceInfo = {
        name: this.getName(),
        platform: this.getPlatform(),
        osVersion: this.getOSVersion(),
        vendor: this.getVendor(),
        model: this.getModel(),
        screenResolution: this.getScreenResolution(),
        cpuArch: this.getCpuArchitecture(),
        cpuCount: this.getCpuCount(),
        gpuVendor: gpu.vendor,
        gpuRenderer: gpu.renderer,
        lang: this.getLang(),
        timezone: this.getTimeZone()
      };
      return DeviceBuilder.deviceInfo;
    }
  }, {
    key: "getName",
    value: function getName() {
      var browser = this.uaParser.getBrowser();
      return "".concat(browser.name, " ").concat(browser.version);
    }
  }, {
    key: "getPlatform",
    value: function getPlatform() {
      return PLATFORM;
    }
  }, {
    key: "getOSVersion",
    value: function getOSVersion() {
      return this.uaParser.getOS().name;
    }
  }, {
    key: "getVendor",
    value: function getVendor() {
      return this.uaParser.getDevice().vendor;
    }
  }, {
    key: "getModel",
    value: function getModel() {
      return this.uaParser.getDevice().model;
    }
  }, {
    key: "getScreenResolution",
    value: function getScreenResolution() {
      if (typeof window === 'undefined' || typeof window.screen === 'undefined') {
        return '';
      }

      return "".concat(window.screen.availWidth, "x").concat(window.screen.availHeight);
    }
  }, {
    key: "getCpuArchitecture",
    value: function getCpuArchitecture() {
      return this.uaParser.getCPU().architecture;
    }
  }, {
    key: "getCpuCount",
    value: function getCpuCount() {
      if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
        return '';
      }

      return "".concat(navigator.hardwareConcurrency);
    }
  }, {
    key: "getGpuInfo",
    value: function getGpuInfo() {
      var gpuInfo = {
        vendor: '',
        renderer: ''
      };

      if (typeof document !== 'undefined') {
        var canvas = document.createElement('canvas');

        if (canvas) {
          var gl = canvas.getContext('webgl');

          if (gl) {
            var debugInfo = gl.getExtension('WEBGL_debug_renderer_info');

            if (debugInfo) {
              gpuInfo.vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
              gpuInfo.renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);
            }
          }
        }
      }

      return gpuInfo;
    }
  }, {
    key: "getLang",
    value: function getLang() {
      if (typeof window === 'undefined' || typeof window.navigator === 'undefined') {
        return '';
      }

      return navigator.language;
    }
  }, {
    key: "getTimeZone",
    value: function getTimeZone() {
      if (typeof Intl !== 'undefined' && Intl.DateTimeFormat) {
        return Intl.DateTimeFormat().resolvedOptions().timeZone;
      }

      var now = new Date();
      var offsetInHours = now.getTimezoneOffset() / 60;
      return "UTC".concat(offsetInHours);
    }
  }]);

  return DeviceBuilder;
}();

export default DeviceBuilder;